/* eslint-disable no-unused-vars */
import React from 'react';
import { getClubTierTypeDisplay, getClubsEmail } from '../../../utils/clubs';
import clubs from '../../../../constants/clubs';
import styles from './splash.scss';

export const AdminsAdded = (props) => {
    return (
        <React.Fragment>
            Admins have been added!
        </React.Fragment>
    );
};

export const MembersInvited = (props) => {
    return (
        <React.Fragment>
            Members have been invited!
        </React.Fragment>
    );
};

export const YouAreMember = (props) => {
    return (
        <React.Fragment>
            You have joined as a member of this club!
        </React.Fragment>
    );
};

export const ClubCreated = (props) => {
    return (
        <React.Fragment>
            Your club has been created!
        </React.Fragment>
    );
};

export const ClubUpdated = (props) => {
    return (
        <React.Fragment>
            Your club has been updated!
        </React.Fragment>
    );
};

export const GroupCreated = (props) => {
    return (
        <React.Fragment>
            Your group has been created!
        </React.Fragment>
    );
};

export const GroupUpdated = (props) => {
    return (
        <React.Fragment>
            Your group has been updated!
        </React.Fragment>
    );
};

const getInactiveClubEmailDisplay = (props) => {
    const emailId = getClubsEmail(props.clubTierType);
    return (
        <u><a style={{ fontWeight: 'inherit' }} className="text-white h6 clickable" href={`mailto: ${emailId}`}>{emailId}</a></u>
    );
};

export const Inactive = (props) => {
    return (
        props.clubTierType.isHighSchool ? (
            <React.Fragment>
                Please email <u><a style={{ fontWeight: 'inherit' }} className="text-white h6 clickable" href={`mailto:${clubs.vipHighSchoolEmail}`}>{clubs.vipHighSchoolEmail}</a></u> for help activating your high school.
            </React.Fragment>
        ) : (
            <React.Fragment>
                Your {getClubTierTypeDisplay(props.clubTierType.name)} {props.clubTierType.isCollege ? '' : 'account'} subscription has expired.
                <br />
                You cannot create events, post scores, or add members until you contact {getInactiveClubEmailDisplay(props)}.
            </React.Fragment>
        )
    );
};

export const PaymentRequired = (props) => {
    const collegeTeamPageText = 'college team page';
    return (
        <React.Fragment>
            {`To continue using your ${props.clubTierType.isCollege ? collegeTeamPageText : getClubTierTypeDisplay(props.clubTierType.name)}, you’ll need to `}
            <u><a style={{ fontWeight: 'inherit' }} className="text-white h6 clickable" onClick={props.onClick}>activate your {getClubTierTypeDisplay(props.clubTierType.name)} Subscription.</a></u>
        </React.Fragment>
    );
};

export const Trialing = (props) => {
    return (
        <React.Fragment>
            Your {getClubTierTypeDisplay(props.clubTierType.name)} trial will end on <u>{props.trialEnd}</u>.
        </React.Fragment>
    );
};

export const CollegeClubBeta = () => {
    return (
        <React.Fragment>
            Thanks for participating in the UTR Sports College Beta!
        </React.Fragment>
    );
};

export const UnclaimedRosterPlayers = (props) => {
    return (
        <React.Fragment>
            In order to post scores for all your players, please ensure your <span className={styles.unclaimedRosterPlayersRosterTabLink} onClick={props.handleOnRosterLinkClick}>roster</span> is complete.
        </React.Fragment>
    );
};
